module.exports = __webpack_public_path__ + "img/Mask_3.67d66c4b.png";